import clsx from "clsx";
import React, { forwardRef, PropsWithChildren } from "react";

export interface ContainerProps {
  containerClassName?: string;
  pagePaddingX?: boolean;
  className?: string;
  containerFrom?: "md" | "lg" | "xl";
}

const containerClasses = {
  md: "md:container md:mx-auto",
  lg: "lg:container lg:mx-auto",
  xl: "xl:container xl:mx-auto",
};

export const Container = forwardRef<HTMLDivElement, PropsWithChildren<ContainerProps>>(
  ({ children, pagePaddingX, containerClassName, className, containerFrom = "md" }, ref) => (
    <div
      className={clsx("w-full flex justify-center", pagePaddingX && "px-8 lg:px-20", className)}
      ref={ref}
    >
      <div className={clsx("w-full", containerClasses[containerFrom], containerClassName)}>
        {children}
      </div>
    </div>
  )
);
